import * as React from 'react';
import { Icon } from '../Icon/Icon.js';

const renderIcon = (id, bem, iconName, iconColor) => {
  if (iconName) {
    return /* @__PURE__ */ React.createElement(Icon, {
      htmlId: id.toHtmlId(),
      className: bem.element("icon")(),
      name: iconName,
      color: iconColor
    });
  }
  return null;
};

export { renderIcon };
